import type { ReactNode } from "react";
import type { PermissionContext } from "@swot/swot-components";
import { CmtsAppLayout } from "@modules/components/layout/index.js";
import type { CmtsHostRuntime } from "../app/appRuntime.js";

export function EnterpriseShell(props: { runtime: CmtsHostRuntime; activePath?: string | undefined; permissionContext?: PermissionContext | null | undefined; children: ReactNode }) {
  return (
    <CmtsAppLayout activePath={props.activePath} diagnostics={props.runtime.diagnostics} permissionContext={props.permissionContext} runtime={props.runtime}>
      {props.children}
    </CmtsAppLayout>
  );
}
